import React, { Fragment, ReactNode } from 'react';
import CategoryTree, { CategoriesTreeInterface, CategoryTreeInterface } from 'modules/shared/components/category-tree';
import Divider from 'atomic/divider';
import { CategoryFull } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';
import { CategoryListingConfig } from 'modules/shared/modules/categories-shared/interfaces/category-listing-config.interface';
import ProducerCategoryTreeBackUrl from 'modules/producers/views/components/producer-category-tree/producer-category-tree-back-url';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import MainTitle from 'modules/shared/components/main-title';
import classNames from 'classnames';
import getCountMax from 'helpers/get-count-max';

import './producer-category-tree-desktop.scss';

export interface ProducerCategoryTreeDesktopProps {
    categoriesTree: CategoriesTreeInterface[];
    category?: CategoryFull<CategoryListingConfig>;
    producerName: string;
    producerSlug: string;
    getUrl: useProducerUrlType;
    h1?: string;
    categoryTreeLimit?: number;
}

const ProducerCategoryTreeDesktop: React.FC<ProducerCategoryTreeDesktopProps> = ({
    categoriesTree,
    category,
    producerName,
    producerSlug,
    getUrl,
    h1,
    categoryTreeLimit = categoriesTree.length
}) => {
    const SHOW_LIMIT = 3;

    const renderTitleAmount = (amount?: number): ReactNode => {
        if (!amount) {
            return null;
        }

        return (
            <>
                {' '}
                <span className="producer-category-tree-d__amount">
                    ({getCountMax(amount)})
                </span>
            </>
        );
    };

    const renderTitleText = (categoryTreeParent: CategoryTreeInterface): ReactNode => {
        if (!category) {
            return (
                <a
                    className="producer-category-tree-d__link"
                    href={categoryTreeParent.url}
                    title={categoryTreeParent.name}
                >
                    {categoryTreeParent.name}
                    {renderTitleAmount(categoryTreeParent.amount)}
                </a>
            );
        }

        return (
            <>
                {(h1 && category) ? h1 : categoryTreeParent.name}
                {renderTitleAmount(categoryTreeParent.amount)}
            </>
        );
    };

    return (
        <div className="producer-category-tree-d">
            { categoriesTree.map((categoryTree, index) => (
                <Fragment key={categoryTree.parent?.id || categoryTree.list[0].id}>
                    {categoryTree.parent && (
                        <MainTitle
                            text={renderTitleText(categoryTree.parent)}
                            className={classNames({
                                'producer-page__title': true,
                                'pb-3': !category,
                                'mb-8': categoryTreeLimit <= index
                            })}
                            htmlTag={category ? 'h1' : 'h2'}
                        />
                    )}
                    {(categoryTreeLimit > index) && (
                        <>
                            <ProducerCategoryTreeBackUrl
                                category={category}
                                categoryTree={categoryTree}
                                producerName={producerName}
                                producerSlug={producerSlug}
                                getUrl={getUrl}
                            />
                            <CategoryTree
                                limitItems={SHOW_LIMIT}
                                categories={[categoryTree]}
                                producerTemplate={true}
                            />
                            {((index + 1) !== categoriesTree.length) && categoriesTree.length > 0 && (
                                <Divider />
                            )}
                        </>
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export default ProducerCategoryTreeDesktop;
